module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JQ7A5G/tc-custom/9781604917123.jpg?1713221604255",
      "alt": "This image is the cover for the book Learning Agility: Unlock the Lessons of Experience"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Learning Agility: Unlock the Lessons of Experience\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Experience is vital for a leader's success, but merely having an experience (such as a challenging new job, a stretch assignment, or an unexpected hardship) isn't enough. The best leaders know not just how to seek out developmental experiences, but how to extract the essential lessons within each experience and apply them to future situations. This book will walk you through a four step process for making the most out of your experiences. You will learn how to seek out beneficial experiences, make sense out of both old and new experiences, internalize the most useful lessons from each experience, and apply those lessons to new, unfamiliar, and challenging situations. By becoming learning agile, you'll be able to use the lessons of experience to meet the challenges headed your way.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George Hallenbeck\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "authorURL body link",
    attrs: {
      "href": "https://www.ccl.org/people/george-hallenbeck/",
      "target": "_blank"
    }
  }, [_vm._v("\n    \n            About Author\n       ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Center for Creative Leadership\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0